//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopEntityComponentAge",
  components: {
    Icon24FillStop: () => import('@/assets/icons/Icon24FillStop.svg?inline')
  },
  props: {
    age: {
      type: Number,
      default: () => 0
    }
  }
}
